import * as React from 'react'
import { tw } from 'utils/classnames'
import { useStudioLayoutContentInset } from './content-inset'

export function StudioLayoutShell({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  const rightInsetPx = useStudioLayoutContentInset()

  return (
    <div
      className={tw(
        'max-w-screen absolute flex h-screen max-h-dvh flex-col',
        rightInsetPx === 0 && 'w-screen',
        className,
      )}
      style={layoutShellWidthStyle(rightInsetPx)}
    >
      {children}
    </div>
  )
}

function layoutShellWidthStyle(insetPx: number): React.CSSProperties | undefined {
  if (insetPx <= 0) {
    return undefined
  }
  return { width: `calc(100vw - ${insetPx}px)` }
}
